export const AccordionTitle = ({
  title,
  count,
}: {
  title: string;
  count?: number;
}) => (
  <span className="inline-flex flex-wrap items-baseline gap-x-1.5">
    <span>{title}</span>
    {typeof count === "number" && count > 0 ? (
      <span className="text-muted-foreground text-sm">({count})</span>
    ) : null}
  </span>
);
